import {defineStore} from "pinia";

export const useWorkerBalanceStore = defineStore('workerBalance', {
    state: () => ({
        workerBalance: {},
        workerBalances: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setWorkerBalance(workerBalance) {
            this.workerBalance = workerBalance
        },
        setWorkerBalances(workerBalances) {
            this.workerBalances = workerBalances
        },
        addWorkerBalance(workerBalance) {
            this.workerBalance = workerBalance;
            this.workerBalances.unshift(workerBalance)
        },
        updateWorkerBalance(workerBalance) {
            this.workerBalance = workerBalance;
            let index = this.workerBalances.findIndex(cl => cl.id === workerBalance.id)
            this.workerBalances.splice(index, 1, workerBalance)
        },
        deleteWorkerBalance(workerBalance) {
            this.workerBalance = {};
            let index = this.workerBalances.findIndex(cl => cl.id === workerBalance.id)
            this.workerBalances.splice(index, 1)
        },
    },
});